"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagManagerService = exports.truck = void 0;
const truck = (name) => {
    // @ts-ignore
    if (dataLayer && dataLayer.push) {
        // @ts-ignore
        dataLayer.push({ 'event': name });
    }
};
exports.truck = truck;
exports.TagManagerService = {
    truck: exports.truck,
};
//# sourceMappingURL=index.js.map